import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=46f41444&"
import script from "./EventEdit.vue?vue&type=script&lang=js&"
export * from "./EventEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports